import { Input, InputChangeEvent } from '@progress/kendo-react-inputs';
import clsx from 'clsx';
import debounce from 'lodash/debounce';
import React, { useCallback, useState } from 'react';
import { CloseIcon, SearchIcon } from 'app/components/icons';
import { BaseButton } from 'app/components/buttons/BaseButton';
import './SearchInput.less';

interface Props {
  value: string;
  placeholder?: string;
  className?: string;
  onChange: (value: string) => void;
}

export default function SearchInput({
  value,
  placeholder,
  className,
  onChange,
}: Props) {
  const [searchTerm, setSearchTerm] = useState(value);

  const handleSearch = useCallback(debounce(onChange, 300), [onChange]);

  const handleChange = (e: InputChangeEvent) => {
    setSearchTerm(e.value);
    handleSearch(e.value);
  };

  return (
    <div className={clsx('base-search-input', className)}>
      <SearchIcon className="base-search-input__search-icon" />

      <Input
        name="equipment_fleets_search"
        value={searchTerm}
        placeholder={placeholder}
        onChange={handleChange}
      />

      {searchTerm && (
        <BaseButton
          className="base-search-input__close-icon"
          onClick={() => setSearchTerm('')}
        >
          <CloseIcon height={24} width={24} />
        </BaseButton>
      )}
    </div>
  );
}
